<template>
    <div>
        <div class="d-flex-center py-5">
            <img
                src="@/assets/report/daily.png">
        </div>
        <v-container>
            <v-row>
                <v-col
                    class="d-flex-center pb-0"
                    offset="4"
                    cols="4">
                        <div class="daily-report-input">
                            <v-menu
                                v-model="datePickerShow"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="dateFormatted"
                                            :label="$vuetify.lang.t('$vuetify.daily.daily')"
                                            prepend-inner-icon="event"
                                            @click:prepend-inner="datePickerShow = true"
                                            readonly
                                            v-on="on">
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    :locale="localeLang"
                                    :max="maxDate"
                                    v-model="datePick"
                                    @input="datePickerShow = false">
                                </v-date-picker>
                            </v-menu>
                        </div>
                </v-col>
                <v-col
                    class="d-flex-space-around pt-0"
                    offset="4"
                    cols="4">
                    <v-btn
                        v-if="showBtn.pdf"
                        color="red lighten-2"
                        class="ma-2 white--text"
                        width="180"
                        height="50"
                        :disabled="!canGenReport"
                        @click="submit(typePdf)">
                        {{ $vuetify.lang.t('$vuetify.daily.exportPDF') }}
                    </v-btn>
                    <v-btn
                        v-if="showBtn.excel"
                        color="green darken-1"
                        class="ma-2 white--text"
                        width="180"
                        height="50"
                        :disabled="!canGenReport"
                        @click="submit(typeExcel)">
                        {{ $vuetify.lang.t('$vuetify.daily.exportExcel') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'Daily',

    props: {
        canGenReport: {
            type: Boolean,
            default: false
        },
        branchId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            datePickerShow: false,
            dateFormatted: this.$util.formatDate(this.$util.getCurrentDate()),
            datePick: this.$util.getCurrentDate(),
            maxDate: this.$util.getCurrentDate(),
            isReportAcp: false,
            typePdf: 'pdf',
            typeExcel: 'excel',
            typeAcp: 'acp',
            exportPath: ''
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        showBtn () {
            return {
                pdf: !this.isReportAcp,
                excel: true
            }
        }
    },

    methods: {
        async submit (reportType) {
            if (this.typePdf === reportType) {
                this.exportPath = 'report/daily/pdf'
                if (this.branchId === 0) {
                    this.exportPath = `${this.exportPath}/branches`
                }
                await this.genPdfDailyReport()
            } else if (this.typeExcel === reportType) {
                if (process.env.VUE_APP_REPORT === 'ACP') {
                    this.exportPath = 'acp/report/daily'
                } else if (process.env.VUE_APP_REPORT === 'default') {
                    this.exportPath = 'report/daily/excel'
                }
                if (this.branchId === 0) {
                    this.exportPath = `${this.exportPath}/branches`
                }
                await this.genExcelDailyReport()
            }
        },

        async genPdfDailyReport () {
            this.$store.dispatch('setLoading', true)
            const response = await this.axios.post(this.exportPath, { date: this.datePick, branch_id: this.branchId }, {
                headers: {
                    'Content-Type': 'application/pdf'
                },
                responseType: 'arraybuffer'
            })

            if (response && response.data) {
                this.$util.downloadPdfFile(response.data)

                this.$store.dispatch('setLoading', false)
            }
        },

        async genExcelDailyReport () {
            this.$store.dispatch('setLoading', true)
            const response = await this.axios.post(this.exportPath, { date: this.datePick, branch_id: this.branchId }, {
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'arraybuffer'
            })

            if (response && response.data) {
                const dateString = this.$util.formatDate(this.datePick)

                this.$util.downloadExcelFile(response.data, `report-${dateString}.xls`)
                this.$store.dispatch('setLoading', false)
            }
        }
    },

    mounted () {
        // console.log(process.env.VUE_APP_REPORT)
        this.isReportAcp = process.env.VUE_APP_REPORT === 'ACP'
    },

    watch: {
        'datePick' () {
            this.dateFormatted = this.$util.formatDate(this.datePick)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
